import crudActions from '../../crud/actions'

const attorneyActions = crudActions('CAREASSESSMENT_ATTORNEYS_')

export default attorneyActions
